import React from 'react';
import './CSSParticles.css';

const CSSParticles = () => {
  // Generate particles
  const particles = Array.from({ length: 50 }, (_, i) => (
    <div
      key={i}
      className="particle"
      style={{
        '--delay': `${Math.random() * 20}s`,
        '--duration': `${15 + Math.random() * 10}s`,
        '--x': `${Math.random() * 100}vw`,
        '--y': `${Math.random() * 100}vh`,
        '--size': `${2 + Math.random() * 4}px`,
        '--rotation': `${Math.random() * 360}deg`,
        '--rotation2': `${Math.random() * 360}deg`,
        '--line1-length': `${30 + Math.random() * 60}px`,
        '--line2-length': `${20 + Math.random() * 50}px`,
      }}
    />
  ));

  return (
    <div className="css-particles-container">
      <div className="cosmic-background" />
      <div className="particles-wrapper">
        {particles}
      </div>
      <div className="cosmic-overlay" />
    </div>
  );
};

export default CSSParticles;